import {useEffect, useRef, useState} from 'react';

// Картинка «готова», когда загружена. Ошибка тоже завершает ожидание — лучше
// показать без одной картинки, чем навсегда застрять на ожидании.
//
// decode() не ждем нарочно: в скрытой вкладке Chrome не выполняет его, пока
// страница снова не станет видимой (проверено в браузере — загруженная
// картинка висела в decode() больше 5 с). Витрина, открытая в фоновой
// вкладке, так и стояла бы под лоадером. Разбор уже загруженной картинки при
// показе занимает миллисекунды
const loadImage = (src) => {
  const image = new Image();
  const promise = new Promise((resolve) => {
    image.onload = () => resolve();
    image.onerror = () => resolve();
  });
  image.src = src;
  return {image, promise};
};

/**
 * Загружает картинки заранее и сообщает, когда все готовы.
 *
 * Готовность относится к конкретному списку: сменился список — снова false,
 * пока не загрузится уже он. Пустой список готов сразу.
 *
 * @param {string[]} srcs - пути картинок; порядок и повторы учитываются как есть
 * @returns {boolean} true, когда все картинки списка загрузились или упали
 */
export function useImagesPreloaded(srcs) {
  const key = (srcs || []).join('\n');
  const [loadedKey, setLoadedKey] = useState(null);
  // Держим сами картинки, пока список актуален: иначе браузер вправе выгрузить
  // уже разобранные данные до того, как их покажут
  const imagesRef = useRef([]);

  useEffect(() => {
    if (!key) {
      imagesRef.current = [];
      return undefined;
    }

    let isCancelled = false;
    const loads = key.split('\n').map(loadImage);
    imagesRef.current = loads.map(({image}) => image);
    Promise.all(loads.map(({promise}) => promise)).then(() => {
      if (!isCancelled) {
        setLoadedKey(key);
      }
    });

    return () => {
      isCancelled = true;
    };
  }, [key]);

  return !key || loadedKey === key;
}
